import React from "react"
import { debounce } from "lodash"
import PropTypes from "prop-types"
import { t } from "i18next"

function SearchInput({ onSearch, defaultValue }) {
  const debouncedOnChange = debounce(event => {
    onSearch && onSearch(event.target.value)
  }, 500)

  return (
    <input
      type="text"
      className="form-control input_search"
      placeholder={t("search")}
      defaultValue={defaultValue}
      onChange={debouncedOnChange}
    />
  )
}
SearchInput.propTypes = {
  onSearch: PropTypes.func,
  defaultValue: PropTypes.string,
}
export default SearchInput
